import { getActivePayOrder } from './api.js'
import util from './util.js'
import chooseFuxunPayment from './fuxunPaymentChoice'
import { paymentReturnPath, replacePaymentRoute } from './paymentReturnPath'
import wx from 'weixin-js-sdk'
import router from '../router'
import store from '@/store'
const Pingpp = require('pingpp-js')
const contextKey = 'fuxunH5Payment'
let submitting = false

const invoke = callback => {
  if (typeof callback === 'function') callback()
}

export const readFuxunPayment = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(contextKey) || 'null')
  } catch (error) {
    return null
  }
}

export const clearFuxunPayment = () => window.sessionStorage.removeItem(contextKey)

export const updateFuxunOrderNo = orderNo => {
  const context = readFuxunPayment()
  if (!context || !orderNo) return
  context.orderNo = orderNo
  context.params = { ...context.params, orderNo }
  window.sessionStorage.setItem(contextKey, JSON.stringify(context))
}

const saveFuxunPayment = (params, orderNo, payment = {}) => {
  const originPath = router.currentRoute.fullPath
  const previous = readFuxunPayment()
  const returnPath = originPath.startsWith('/fuxunPayResult') && previous
    ? previous.returnPath : originPath
  const context = {
    orderNo: orderNo || params.orderNo,
    marketId: store.state.common.marketInfo.id,
    returnPath: paymentReturnPath(returnPath, store.state.common.marketInfo.id),
    params: { ...params, orderNo: orderNo || params.orderNo },
    paymentMethod: payment.paymentMethod,
    qrCodeUrl: payment.qrCodeUrl,
    expiresAt: Number(payment.expiresAt || 0),
    amount: payment.amount,
    createdAt: Date.now()
  }
  window.sessionStorage.setItem(contextKey, JSON.stringify(context))
}

const openFuxunCashier = async (payment, params) => {
  if (payment.paymentScene === 'OFFICIAL_ACCOUNTS' && payment.orderStatus === '02') {
    saveFuxunPayment(params, payment.orderNo)
    router.push({ path: '/fuxunPayResult', query: { marketId: store.state.common.marketInfo.id } })
    return
  }
  if (payment.paymentScene === 'OFFICIAL_ACCOUNTS' && payment.paymentMethod === 'ALIPAY') {
    const image = new URL(payment.qrCodeUrl || '')
    if (image.protocol !== 'https:' || image.username || image.password || image.hash
        || !Number.isFinite(Number(payment.expiresAt)) || Number(payment.expiresAt) <= Date.now()) {
      throw new Error('二维码图片无效或已过期，请查询订单后再处理')
    }
    saveFuxunPayment(params, payment.orderNo, payment)
    router.push({ path: '/fuxunPayResult', query: { marketId: store.state.common.marketInfo.id } })
    return
  }
  const link = document.createElement('a')
  link.href = payment.prepayid || ''
  if (link.protocol !== 'https:' || !/(^|\.)fuxunpay\.com$/.test(link.hostname)
      || payment.paymentScene !== 'OFFICIAL_ACCOUNTS') {
    throw new Error('福讯收银台地址无效，请稍后重试')
  }
  saveFuxunPayment(params, payment.orderNo)
  // Back from the external cashier must restore a queryable page rather than a stale checkout.
  await replacePaymentRoute(router, { path: '/fuxunPayResult', query: { marketId: store.state.common.marketInfo.id } })
  if (router.currentRoute.path !== '/fuxunPayResult') throw new Error('支付结果页打开失败，请稍后重试')
  submitting = false
  window.location.assign(link.href)
}

const wechatPay = (payment, success, failure, cancel) => {
  return new Promise(resolve => wx.chooseWXPay({
    timestamp: payment.timeStamp,
    nonceStr: payment.nonceStr,
    package: payment.package,
    signType: payment.signType,
    paySign: payment.sign,
    success: () => { invoke(success); resolve() },
    fail: () => { invoke(failure); resolve() },
    cancel: () => { invoke(cancel); resolve() }
  }))
}

const pingppPay = (payment, success, failure, cancel) => {
  return new Promise(resolve => Pingpp.createPayment(payment, result => {
    if (result === 'success') {
      util.showToast('支付成功')
      invoke(success)
    } else if (result === 'fail') {
      util.showToast('支付失败')
      invoke(failure)
    } else if (result === 'cancel') {
      util.showToast('已取消支付')
      invoke(cancel)
    }
    resolve()
  }))
}

const pay = (params, header, success, failure, cancel, changed) => {
  if (submitting) return Promise.resolve()
  submitting = true
  util.showLoading()
  const offline = String(params.payType) === '6' || String(params.payType) === '9'
  const request = offline ? params : { ...params, paymentScene: 'OFFICIAL_ACCOUNTS', fuxunMethod: params.fuxunMethod || 'CHOOSE' }
  try {
    if (!offline) saveFuxunPayment(request)
  } catch (error) {
    submitting = false
    util.hideLoading()
    util.showToast('无法保存支付上下文，请检查浏览器存储设置', 2000)
    return Promise.resolve()
  }
  return getActivePayOrder(request, header).then(async response => {
    if (response.res && response.res.code === 10000 && response.body
        && String(response.body.payType) === '8' && response.body.choosePaymentMethod === 'true') {
      util.hideLoading()
      const method = await chooseFuxunPayment()
      if (!method) { invoke(cancel); return }
      request.fuxunMethod = method
      util.showLoading()
      response = await getActivePayOrder(request, header)
    }
    util.hideLoading()
    if (!response.res) throw new Error('支付接口返回异常')
    if (response.res.code === 10009) {
      invoke(changed)
      return
    }
    if (response.res.code !== 10000 || !response.body) {
      if (offline && response.res.code === 10000) invoke(success)
      else util.showToast(response.res.msg || '支付未完成，请稍后重试', 2000)
      return
    }
    if (offline) {
      invoke(success)
    } else if (String(response.body.payType) === '8') {
      return openFuxunCashier(response.body, request)
    } else if (String(response.body.payType) === '7') {
      return wechatPay(response.body, success, failure, cancel)
    } else {
      return pingppPay(response.body, success, failure, cancel)
    }
  }).catch(error => {
    util.showToast(error.message || '支付请求未确认，请稍后查看订单', 2000)
  }).then(() => {
    submitting = false
    util.hideLoading()
  })
}

export default pay
